export default [
    {
        name: 'warehouse.items.index',
        path: '/warehouse/items',
        prop: {
            type: 'all'
        },
        component: () => import("@/views/modules/warehouse/items/List.vue"),
    },
    {
        name: 'warehouse.pick.items.index',
        path: '/warehouse/pick/items',
        props: {
            type: 'pick'
        },
        component: () => import("@/views/modules/warehouse/items/List.vue"),
    },
    {
        name: 'warehouse.move.items.index',
        path: '/warehouse/move/items',
        props: {
            type: 'move'
        },
        component: () => import("@/views/modules/warehouse/items/List.vue"),
    },
    {
        name: 'warehouse.return.items.index',
        path: '/warehouse/return/items',
        props: {
            type: 'return'
        },
        component: () => import("@/views/modules/warehouse/items/List.vue"),
    }

]
